<template>
	<dl class="itemCd sort-item">
		<dt>{{ $t('common.labels.productCode') }}</dt>
		<dd>{{ ptInitData.productInfo.S_ITEM_NO }}</dd>
	</dl>
</template>
<script>
export default {
	methods: {
	},
	name: 'productCode',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	}
} 
</script>